import { useState, useEffect, useRef, useMemo } from "react";

import { Badge, Row, Col, Form, Modal, Button, Tab, Tabs, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faSave } from '@fortawesome/free-solid-svg-icons';
import pen from "../../../../assets/images/pen.png";
import Face from "../../../../assets/images/user.png";
import save from '../../../../assets/images/save.svg';

import { CallApi, CommonModal, getTodayDateTime } from "../../../../Components/common/CommonFunctions";
import Attachment from "../../../../Components/common/Attachment";
import { Remarks, RemarksForm } from "../../../../Components/common/Remarks";
import TableGrid from "../../../../Components/common/TableGrid";
import { useGetShipmentListQuery } from "../../../../redux/services/SPL";
import { useSelector } from "react-redux";

const TripModal = ({ propData, show, onHide, page = null, onEditTrip  }) => {

    console.log("propDataaaa",propData)

    const isMounted = useRef(false);
    const initialFormData = { shipment: [], driver_image: Face }
    const [formData, setFormData] = useState(initialFormData);
    const [tripFormData, setTripFormData] = useState(initialFormData);
    const [modalTab, setModalTab] = useState('Dt');
    const [edited, setEdited] = useState(false);
    const fileInputRef = useRef(null);
    const [disLoading, setDisLoading] = useState(false);
    const [confShow, setConfShow] = useState(false);
    const [sendData, setSendData] = useState({});
    const [editData, setEditData] = useState();
    const isTripsPage = page === 'trips';
    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

    const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value);
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);
    const params = {
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      id:propData.id
    };
    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    return params;
  }, [filters, pageDetails, sortby]);

    const { data: myData, isFetching, refetch } = useGetShipmentListQuery(queryParams, {
        skip: pageDetails.pagesize === 0,
        refetchOnMountOrArgChange: true,
    });

    const loadDetails = (uldNumber, pos) => {
        setDisLoading(true);
        const endPoint = isTripsPage
            ? `trip-details`
            : `trip-management/get-slot-details/${uldNumber}`;
        const payload = isTripsPage ? { trip_id: propData?.trip_id } : {};
        CallApi({
            endPoint,
            payload,
            onSuccess: (res) => {
                if (page !== 'trips') {
                    const resCode = res.data.response_code;
                    if (resCode === 200) {
                        const innerData = res.data.response_data;
                        if (pos === 'V') {
                            setFormData({
                                ...innerData,
                                timeslot_booked: getTodayDateTime(innerData.created_at),
                                driver_image: innerData?.driver_image ?? initialFormData.driver_image,
                                gate_in: innerData?.gate_in
                                    ? innerData.gate_in.split(' ')[0] + ' ' + innerData.gate_in.split(' ')[1].substring(0, 5)
                                    : ''
                            });
                            setSendData({ attType: 'all_trip', id: innerData.id });
                        }
                    }
                } else if (page === 'trips') {
                    const data = res?.data?.response_data
                    setTripFormData({
                        ...data,
                        // timeslot_booked: getTodayDateTime(innerData.created_at),
                        driver_image: data?.trip_details?.driver_image ?? initialFormData.driver_image,
                        // gate_in: innerData?.gate_in
                        //     ? innerData.gate_in.split(' ')[0] + ' ' + innerData.gate_in.split(' ')[1].substring(0, 5)
                        //     : ''
                    });
                }
                setDisLoading(false);
            },
            onError: (msg) => {
                toast.error(msg);
                setDisLoading(false);
            }
        });
    };

    useEffect(() => {
        if (isMounted.current) return;
        loadDetails(propData.id, propData.ps)
        isMounted.current = true;
    }, []);

    const columns = [
        { label: "AWB No.", field: "awb_no", enableSearch: false, cls: "tw-6" },
        { label: "Pieces", field: "total_pieces_awb", enableSearch: false, cls: "tw-6" },
        { label: "Weight", field: "total_weight_awb", enableSearch: false, cls: "tw-6" },
        { label: "PRE (Pieces)", field: "pre_total_actual_pieces_awb", enableSearch: false, cls: "tw-6" },
        { label: "MAN (Pieces)", field: "total_actual_pieces_awb", enableSearch: false, cls: "tw-6" },
        { label: "MAN Time", field: "last_update", enableSearch: false, cls: "tw-6" },
        { label: "DEP (Pieces)", field: "dep_total_actual_pieces_awb", enableSearch: false, cls: "tw-6" },
        { label: "DEP Time", field: "dep_last_update", enableSearch: false, cls: "tw-6" },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
        setEdited(true)
    }
    const handleSave = () => {
        CallApi({
            endPoint: `trip-management/update-slot/${formData.id}`,
            method: 'patch',
            payload: formData,
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    if (confShow) {
                        setConfShow(false)
                    }
                    setEdited(false)
                    propData();
                    // refetch()
                    toast.success(res.data.response_msg)
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });


    }
    const handleModalTabChange = (tab) => {
        setModalTab(tab);
    }
    const handleProfileImageChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = () => {
            const base64 = reader.result;
            setFormData((prev) => {
                const updatedForm = {
                    ...prev,
                    driver_image: base64,
                };
                return updatedForm;
            });
        };

        reader.readAsDataURL(file);
    };
    const handleModalClose = () => {
        if (edited) {
            setConfShow(true)
        } else {
            onHide();
            setFormData(initialFormData);
        }
    }
    const confClose = () => {
        setConfShow(false)
        setEdited(false)
        onHide();
        setFormData(initialFormData);
    }

    return (
        <>
            {disLoading ? <div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div> : ''}
            {console.log("the trip form Data is", tripFormData)}
            <CommonModal
                show={confShow}
                onHide={confClose}
                title='Unsaved Changes'
                className='addfrom slot_conf'
                footer={
                    <div className='d-flex justify-content-between are_bottom'>
                        <Button variant="secondary" onClick={confClose}>
                            <FontAwesomeIcon icon={faXmark} /> Don't Save
                        </Button>
                        <Button variant="primary" onClick={handleSave}>
                            <FontAwesomeIcon icon={faSave} /> Save
                        </Button>
                    </div>
                }>
                <p>You have made changes that have not been saved.<br />If you continue, all unsaved changes will be lost.</p>
            </CommonModal>
            <Modal show={show} className='addfrom  alltrips_slot_modal' size='xl' centered> {/* change_type */}
                <Modal.Header closeButton onClick={handleModalClose}>
                </Modal.Header>
                <Modal.Body>
                    <div className="slot_wrapper_1">
                        <div>
                            {!isTripsPage && (<>
                                <h3>{formData?.trip_no}</h3>

                                <div className={`status ${formData?.status === "O" ? "bg-gry" : formData?.status === "C" ? "bgc-grn" : "bgc-org"}`}>
                                    <span className="stat-txt">{formData?.status === 'O' ? 'Open' : formData.status === 'C' ? 'Complete' : 'In progress'}</span>
                                </div></>)}
                            {!isTripsPage && modalTab === "mils" && (
                                <button className="save_btn" onClick={handleSave}>
                                    <img src={save} alt="save" />
                                    Save
                                </button>
                            )}
                            {isTripsPage && (<>
                                <h3>{tripFormData?.trip_details?.trip_no}</h3>
                                <span><button className='edit_btn mb-1 me-1'  onClick={() => onEditTrip(tripFormData)}><img src={pen} alt='pen' />Edit Trip</button></span>
                                {/* <div className={`status ${formData?.status === "O" ? "bg-gry" : formData?.status === "C" ? "bgc-grn" : "bgc-org"}`}>
                                <span className="stat-txt">{formData?.status === 'O' ? 'Open' : formData.status === 'C' ? 'Complete' : 'In progress'}</span>
                            </div> */}
                            </>)}
                            {/* <span className='progrss_btn'><img src={orange_circles} alt='orange_circles' />In Progress</span> */}
                        </div>
                        <Tabs defaultActiveKey={modalTab} onSelect={(tab) => modalTab !== tab ? handleModalTabChange(tab) : ''} className="booking_tab mdl_tb">

                            <Tab eventKey="Dt" title={<span>Details <Badge className='rabadge'></Badge></span>} className='moveto details_tab'>
                                {/* <div className="slot-actions">
                                    <div className="left-actions">
                                        <span className='note-icon'><FontAwesomeIcon icon={faListCheck} /></span>
                                        <button className="save-close">Save and close</button>
                                    </div>
                                    <div className="right-actions">
                                        <span className='note-icon'><FontAwesomeIcon icon={faPrint} /></span>
                                    </div>
                                    </div> */}
                                <Row className='g-2'>
                                    <Col md={5}>
                                        <div className="slot-card-dv">
                                            <h6>Driver Details</h6>
                                            {!isTripsPage && (<>
                                                <div className="driver-row">
                                                    <div className='d-flex'>
                                                        <span className='driver-img-dv'>
                                                            <img
                                                                src={formData?.driver_image}
                                                                className="driver-img"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleProfileImageChange}
                                                            />
                                                            {/* <span
                                                            className="img_cam"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => fileInputRef.current.click()}
                                                            >
                                                            <FontAwesomeIcon icon={faCamera} />
                                                            </span> */}
                                                        </span>
                                                        <span>
                                                            <h5 className="driver-name">{formData?.booking?.trip?.driver1_first_name} {formData?.booking?.trip?.driver1_last_name}</h5>
                                                            {/* <p className="driver-phone"><img src={faPhone} alt='faPhone' className='pe-2' />+49 123 4567890</p> */}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <h5 className='driver_count'>1st Driver</h5>
                                                    </div>
                                                </div>

                                                <div className="driver-row">
                                                    <div className='d-flex'>
                                                        <span className='driver-img-dv'>
                                                            <img
                                                                src={formData?.driver_image}
                                                                className="driver-img"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleProfileImageChange}
                                                            />
                                                            {/* <span
                                                            className="img_cam"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => fileInputRef.current.click()}
                                                            >
                                                            <FontAwesomeIcon icon={faCamera} />
                                                            </span> */}
                                                        </span>
                                                        <span>
                                                            <h5 className="driver-name">{formData?.booking?.trip?.driver2_first_name} {formData?.booking?.trip?.driver2_last_name}</h5>
                                                            {/* <p className="driver-phone"><img src={faPhone} alt='faPhone' className='pe-2' />+49 123 4567890</p> */}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <h5 className='driver_count'>2nd Driver</h5>
                                                    </div>
                                                </div></>)}
                                            {isTripsPage && (<>
                                                <div className="driver-row">
                                                    <div className='d-flex'>
                                                        <span className='driver-img-dv'>
                                                            <img
                                                                src={tripFormData?.driver_image}
                                                                className="driver-img"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleProfileImageChange}
                                                            />
                                                            {/* <span
                                                            className="img_cam"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => fileInputRef.current.click()}
                                                            >
                                                            <FontAwesomeIcon icon={faCamera} />
                                                            </span> */}
                                                        </span>
                                                        <span>
                                                            <h5 className="driver-name">{tripFormData?.trip_details?.driver1_first_name} {tripFormData?.trip_details?.driver1_last_name}</h5>
                                                            {/* <p className="driver-phone"><img src={faPhone} alt='faPhone' className='pe-2' />+49 123 4567890</p> */}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <h5 className='driver_count'>1st Driver</h5>
                                                    </div>
                                                </div>

                                                <div className="driver-row">
                                                    <div className='d-flex'>
                                                        <span className='driver-img-dv'>
                                                            <img
                                                                src={tripFormData?.driver_image}
                                                                className="driver-img"
                                                            />
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleProfileImageChange}
                                                            />
                                                            {/* <span
                                                            className="img_cam"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => fileInputRef.current.click()}
                                                            >
                                                            <FontAwesomeIcon icon={faCamera} />
                                                            </span> */}
                                                        </span>
                                                        <span>
                                                            <h5 className="driver-name">{tripFormData?.trip_details?.driver2_first_name} {tripFormData?.trip_details?.driver2_last_name}</h5>
                                                            {/* <p className="driver-phone"><img src={faPhone} alt='faPhone' className='pe-2' />+49 123 4567890</p> */}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <h5 className='driver_count'>2nd Driver</h5>
                                                    </div>
                                                </div>
                                            </>)}
                                        </div>
                                        <div className="slot-card-dv trip_details_card">
                                            <h6>Trip Details</h6>
                                            {!isTripsPage && (
                                                <div className='flex_colum'>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Organisation</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="Wallenborn"
                                                            value={formData?.creator_org?.org_Name}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Trip Type</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="RFS-Loading"
                                                            value={`${formData?.trip_type?.name}-${formData?.booking?.shipping_type === 'L' ? 'Loading' : 'Unloading'}`}
                                                        // onChange={handleChange)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Export/Import</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="Export"
                                                            value={formData?.booking?.trip?.trip_status}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Truck License Plate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="SK-451-T"
                                                            value={formData?.booking?.trip?.vehicle_license}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Trailer License Plate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="RK-140-P"
                                                            value={formData?.booking?.trip?.trailer_license}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                </div>)}
                                            {isTripsPage && (
                                                <div className='flex_colum'>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Export/Import</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="Export"
                                                            value={tripFormData?.trip_details?.trip_status}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Truck License Plate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="SK-451-T"
                                                            value={tripFormData?.trip_details?.truck_license_plate}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Trailer License Plate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="RK-140-P"
                                                            value={tripFormData?.trip_details?.trailer_license_plate}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>

                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                    {!isTripsPage && (
                                        <Col md={7}>
                                            <div className="slot-card-dv slot_information_dv">
                                                <h6>Slot Information </h6> {/* <span><Button className='edit_btn'><img src={pen} alt='pen' />Modify Slot</Button></span> */}

                                                <div className='flex_colum'>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Planned Time</Form.Label>

                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="version"
                                                            placeholder="datetime-local"
                                                            disabled
                                                            value={formData.planned_date_time}
                                                        // onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-1'>
                                                        <Form.Label>Timeslot</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="version"
                                                            placeholder="datetime-local"
                                                            disabled
                                                            value={formData?.booking?.request_booking_slot}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center'>
                                                        <Form.Label>Door No.</Form.Label>
                                                        {/* <Select
                                                        options={[]}
                                                        // value={[]}
                                                        // onChange={handleChange}
                                                        placeholder="Select Door No."
                                                        isClearable
                                                    /> */}
                                                        <Form.Control
                                                            type="number"
                                                            name="version"
                                                            placeholder="26"
                                                            disabled
                                                            value={formData?.door_details?.door_no}
                                                        // onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className="slot-card-dv truck_order_details_dv">
                                                <h6>Truck Order Details</h6>

                                                <div className="table-wrapper">
                                                    <Table className="truck_order_details_table">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th>Truck No.</th>
                                                                <th>Truck Date</th>
                                                                <th>Intact/Loose</th>
                                                                <th>Loading Sequence</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData?.booking?.trucks.length ?
                                                                <>
                                                                    {formData?.booking?.trucks?.map((item, index) => (
                                                                        <tr key={`trucks_${index}`}>
                                                                            <td className="action-col">
                                                                                {/* <img src={blue_eye} alt='blue_eye' /> */}
                                                                            </td>
                                                                            <td>{item.flight_prefix}{item.flight_no}</td>
                                                                            <td>{item.truck_date}</td>
                                                                            <td>{item.intact_loose}</td>
                                                                            <td>{item.loading_sequence}</td>
                                                                        </tr>
                                                                    ))}
                                                                </>
                                                                :
                                                                <tr><td colSpan={5}> No Data Available</td></tr>
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </Col>)}
                                    {isTripsPage && (
                                        <Col md={7}>
                                            <div className="slot-card-dv slot_information_dv">
                                                <h6>Trip Stops </h6>
                                                <div className='scroll_auto'>
                                                    {tripFormData?.slot_booking?.map((slot, index) => {
                                                        let status = slot?.all_trips?.[0]?.trip_status?.name;
                                                        let btnClass = "orng_btn";
                                                        if (status == "Timeslot Booked") {
                                                            btnClass = "gray_btn";
                                                        } else if (status == "Completed") {
                                                            btnClass = "green_btn";
                                                        }
                                                        const status_id = slot?.all_trips?.[0]?.trip_status?.id;
                                                        const status_name = slot?.all_trips?.[0]?.trip_status?.name || "";
                                                        if (status_id == 210 || status_id == 211) {
                                                            let shippingType = "";
                                                            if (slot?.shipping_type === "L") {
                                                                shippingType = "Loading ";
                                                            } else if (slot?.shipping_type === "U") {
                                                                shippingType = "Unloading ";
                                                            }
                                                            status = shippingType + status_name;
                                                        } else {
                                                            status = status_name;
                                                        }
                                                        return (
                                                            <div key={index} className="slot-card-dv slot_information_dv md_brd">
                                                                <h6>{slot.handler_name + " "}- {slot.shipping_type === "L" ? "Loading" : slot.shipping_type === "U" ? "Unloading" : "Unknown"}{" "}<span className={btnClass}>{status}</span></h6>
                                                                <div className="flex_colum">
                                                                    <Form.Group className="d-flex align-items-center mb-1">
                                                                        <Form.Label>Planned Time</Form.Label>
                                                                        <Form.Control
                                                                            type="datetime-local"
                                                                            disabled
                                                                            value={slot.planned_date_time}
                                                                        />
                                                                    </Form.Group>

                                                                    <Form.Group className="d-flex align-items-center mb-1">
                                                                        <Form.Label>Timeslot</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            disabled
                                                                            value={slot.request_booking_slot}
                                                                        />
                                                                    </Form.Group>

                                                                    <Form.Group className="d-flex align-items-center">
                                                                        <Form.Label>Door No.</Form.Label>
                                                                        <Form.Control
                                                                            type="number"
                                                                            disabled
                                                                            value={slot?.door?.door_no}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                            </div>);
                                                    })}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                </Row>
                            </Tab>

                            <Tab eventKey="mils" title={<span>Milestone <Badge className='rabadge'></Badge></span>} className='moveto milestone_tab'>
                                {/* <div className="slot-actions">
                                    <div className="left-actions">
                                        <span className='note-icon'><FontAwesomeIcon icon={faListCheck} /></span>
                                        <button className="save-close">Save and close</button>
                                    </div>
                                    <div className="right-actions">
                                        <span className='note-icon'><FontAwesomeIcon icon={faPrint} /></span>
                                    </div>
                                    </div> */}
                                {!isTripsPage && (
                                    <Row>
                                        <Col md={12}>
                                            <div className='slot-card slot-card-dv'>
                                                <h6>Milestones</h6>
                                                <div className='p-3'>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-2'>
                                                        <Form.Label>Timeslot Booked</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="timeslot_booked"
                                                            placeholder="2024-03-28 15:00"
                                                            disabled
                                                            value={formData.timeslot_booked}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-2'>
                                                        <Form.Label>Gate In</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="gate_in"
                                                            placeholder="2024-03-28 15:00"
                                                            value={formData.gate_in}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-2'>
                                                        <Form.Label>Office In</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="office_in"
                                                            placeholder="2024-03-28 15:00"
                                                            value={formData.office_in}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-2'>
                                                        <Form.Label>Start Loading</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="start_loading"
                                                            placeholder="2024-03-28 15:00"
                                                            value={formData.start_loading}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-2'>
                                                        <Form.Label>End Loading</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="end_loading"
                                                            placeholder="2024-03-28 15:00"
                                                            value={formData.end_loading}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-2'>
                                                        <Form.Label>Office Out</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="office_out"
                                                            placeholder="2024-03-28 15:00"
                                                            value={formData.office_out}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-2'>
                                                        <Form.Label>Gate Out</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="gate_out"
                                                            placeholder="2024-03-28 15:00"
                                                            value={formData.gate_out}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            {/* <button className="save_btn" onClick={handleSave}><img src={save} alt="save" />Save</button> */}
                                        </Col>
                                    </Row>)}
                                {isTripsPage && (
                                    <Row>
                                        {tripFormData?.slot_booking?.map((slot, index) => {
                                            const trip = slot?.all_trips?.[0];
                                            if (!trip) return null;
                                            const shippingTypeLabel = slot.shipping_type === "L" ? "Loading" : slot.shipping_type === "U" ? "Unloading" : "Unknown";
                                            return (
                                                <Col md={5} key={index}>
                                                    <div className="slot-card slot-card-dv">
                                                        <h6>
                                                            {slot.handler_name} - {shippingTypeLabel}
                                                        </h6>
                                                        <div className="p-3">
                                                            <Form.Group className="d-flex align-items-center mb-2">
                                                                <Form.Label>Timeslot Booked</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    disabled
                                                                    // value={trip.slot_start_time?.replace(" ", "T").slice(0, 16)}
                                                                    value={getTodayDateTime(trip.created_at)}
                                                                />
                                                            </Form.Group>

                                                            <Form.Group className="d-flex align-items-center mb-2">
                                                                <Form.Label>Gate In</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    disabled
                                                                    value={trip.gate_in?.replace(" ", "T").slice(0, 16) || ""}
                                                                />
                                                            </Form.Group>

                                                            <Form.Group className="d-flex align-items-center mb-2">
                                                                <Form.Label>Office In</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    disabled
                                                                    value={trip.office_in?.replace(" ", "T").slice(0, 16) || ""}
                                                                />
                                                            </Form.Group>

                                                            <Form.Group className="d-flex align-items-center mb-2">
                                                                <Form.Label>Start Loading</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    disabled
                                                                    value={trip.start_loading?.replace(" ", "T").slice(0, 16) || ""}
                                                                />
                                                            </Form.Group>

                                                            <Form.Group className="d-flex align-items-center mb-2">
                                                                <Form.Label>End Loading</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    disabled
                                                                    value={trip.end_loading?.replace(" ", "T").slice(0, 16) || ""}
                                                                />
                                                            </Form.Group>

                                                            <Form.Group className="d-flex align-items-center mb-2">
                                                                <Form.Label>Office Out</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    disabled
                                                                    value={trip.office_out?.replace(" ", "T").slice(0, 16) || ""}
                                                                />
                                                            </Form.Group>

                                                            <Form.Group className="d-flex align-items-center mb-2">
                                                                <Form.Label>Gate Out</Form.Label>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    disabled
                                                                    value={trip.gate_out?.replace(" ", "T").slice(0, 16) || ""}
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                )}
                            </Tab>

                            <Tab eventKey="shipment" title={<span>Shipments <Badge className='rabadge'></Badge></span>} className='moveto milestone_tab'>
                                <TableGrid
                                    columns={columns}
                                    rows={myData?.Rows}
                                    totalRecords={myData?.TotalRows || 0}
                                    onClickRow={(row) => {
                                        console.log("Clicked Row:", row);
                                    }}
                                    loading={isFetching}
                                    // bulkActions={bulkActions}
                                    rowKey="id"
                                />
                            </Tab>
                            {/* {isTripsPage && (
                                <Tab eventKey="trko" title={<span>Truck Orders <Badge className='rabadge'></Badge></span>} className='moveto milestone_tab'>

                                </Tab>)} */}


                            {/* <Tab eventKey="ship" title={<span>Shipments <Badge className='rabadge'></Badge></span>} className='moveto'> */}
                            {/* <div className='rounded' style={{ background: '#fff' }}>
                                <Table responsive borderless>
                                    <thead>
                                    <tr>
                                        <th>AWB No.</th>
                                        <th>ULD No.</th>
                                        <th>Pieces</th>
                                        <th>Weight</th>
                                        <th>Volume</th>
                                        <th>Special Handling Code</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {formData?.shipments?.length ?
                                        <>
                                        {formData?.shipments.map((data, index) => (
                                            <tr key={index}>
                                            <td><h6>{data?.updated_by_name}</h6><p>{data?.type}</p></td>
                                            <td>{data?.pieces_traced}</td>
                                            <td>{data?.tracing_date}</td>
                                            <td>{data?.updated_at_date}</td>
                                            <td>{data?.volume}</td>
                                            <td>{data?.special_handling_code}</td>
                                            </tr>
                                        ))}
                                        </>
                                        :
                                        <td colSpan={6}><div style={{ textAlign: 'center' }} className='mt-3'>No Data Available</div></td>
                                    }
                                    </tbody>
                                </Table>
                                </div> */}
                            {/* </Tab> */}
                            {!isTripsPage && (<Tab eventKey="attachments" title={<span>Attachments <Badge className='rabadge'></Badge></span>} className='moveto attachments_cmn'>
                                <Row>
                                    <Col md={12}>
                                        <Attachment propData={formData} submitData={sendData} onReload={() => loadDetails(formData.id, 'V')} />
                                    </Col>
                                </Row>
                            </Tab>)}
                            {!isTripsPage && (
                                <Tab eventKey="Remarks" title={<span>Remarks <Badge className='rabadge'></Badge></span>} className='moveto remarks_tab '>
                                    <Row>
                                        <Col md={6} className="pe-0 remarks_scroll">
                                            <Remarks propData={formData?.activities} onReload={() => loadDetails(formData.id, 'V')} onEdit={(e) => setEditData(e)} />
                                        </Col>
                                        <Col md={6}>
                                            <RemarksForm propInfo={sendData} eData={editData} onReload={() => { loadDetails(formData.id, 'V'); setEditData() }} />
                                        </Col>
                                    </Row>
                                </Tab>)}

                            {/* <Button variant="primary">Primary</Button> */}
                        </Tabs>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default TripModal